import { useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { useApiMutation } from '../useApiMutation';
import { apiPost, operationsClient } from '@/lib/api';
import { jobEndpoints } from '@/lib/api/endpoints';
import { jobKeys } from '@/lib/queryKeys';
import type { Job } from '@/types/job';

export function useRestoreJob() {
  const queryClient = useQueryClient();

  return useApiMutation<Job, string>({
    mutationFn: (id) => apiPost<Job>(operationsClient, jobEndpoints.restore(id)),
    showErrorToast: false,
    onSuccess: (data) => {
      void queryClient.invalidateQueries({ queryKey: jobKeys.lists() });
      void queryClient.invalidateQueries({ queryKey: jobKeys.detail(data.id) });
      toast.success('Job restored to Draft');
    },
  });
}
